module.exports = __webpack_public_path__ + "static/img/Bitmap2@2x.7b110d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Bitmap2@2x.png
// module id = 7zx6
// module chunks = 1